import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="planes" className="w-full bg-blue-50 py-16 md:py-24" data-id="element-151" data-mp="2jlpfetvaearh">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-152" data-mp="1vutglcseyfaq">
        {showUrgency && <CountdownPanel data-id="element-153" data-mp="1rt83prfvq10j" />}

        <h2 className="mt-16 text-center font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-154" data-mp="1ru166g7t24cv">
          Tu <span className="text-blue-600" data-id="element-155" data-mp="20t4qtommerth">MegaPack Método Mente Viva</span>
        </h2>

        <div className="mx-auto mt-10 max-w-narrow rounded-2xl bg-white p-7 shadow-lift ring-2 ring-blue-600 md:p-10" data-id="element-156" data-mp="20vhf0jiz1yez">
          <p className="text-center font-display text-xl font-extrabold uppercase tracking-tight text-ink md:text-2xl" data-id="element-157" data-mp="3c8jv7dh5slym">
            {offer.name}
          </p>
          <p className="mt-2 text-center text-lg text-blue-900/75" data-id="element-158" data-mp="3vz72o2kemxs4">{offer.summary}</p>

          <ul className="mx-auto mt-8 grid max-w-xl gap-4 text-left sm:grid-cols-2" data-id="element-159" data-mp="4rkq1kfpjkz4">
            {offer.includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-160" data-mp="9qe8lr9uq265">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-mint-50 text-mint-600" data-id="element-161" data-mp="eqti27r0ipiu">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-162" data-mp="3d74hqf0qcvc2" />
                </span>
                <span className="text-ink" data-id="element-163" data-mp="3i5xshzomu88j">{item}</span>
              </li>)}
          </ul>

          <div className="mt-10 text-center" data-id="element-164" data-mp="3n5ai2s6w1tet">
            <p className="text-lg text-blue-900/45 line-through" data-id="element-165" data-mp="3rywwopwm47d9">{offer.listPrice} ARS</p>
            <p className="font-display text-5xl font-extrabold tracking-tight text-ink md:text-6xl" data-id="element-166" data-mp="2uj99fanw09qc">
              {offer.price}
              <span className="ml-2 text-xl font-semibold text-blue-900/55" data-id="element-167" data-mp="2zfznxtk1mx9n">ARS</span>
            </p>
          </div>

          <div className="mt-8" data-id="element-168" data-mp="2res0w4ik4swv">
            <CtaButton size="xl" className="w-full" href="#planes" data-id="element-169" data-mp="2mi1k1eyxhtae">
              {offer.cta}
            </CtaButton>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-170" data-mp="3164tiyc6jn3y">
          <li className="inline-flex items-center gap-2" data-id="element-171" data-mp="2w9xkgwohlvhs">
            <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-172" data-mp="28is66ly73b9l" /> Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-173" data-mp="23kgvya3zmyqu">
            <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-174" data-mp="2igpsv50ep003" /> Acceso en 5 minutos
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-175" data-mp="2dgu061x5suzu">
            <ShieldCheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-176" data-mp="2djg6xzc876h0" /> Garantía 7 días
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-177" data-mp="3ow8vl19pzesu">
            <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-178" data-mp="3ovqotapfli6o" /> Mercado Pago | Transferencia
          </li>
        </ul>
      </div>
    </section>;
}